import React from 'react';

import environment from '@department-of-veterans-affairs/platform-utilities/environment';

import {
  fileInputMultipleSchema,
  fileInputMultipleUI,
  titleUI,
} from 'platform/forms-system/src/js/web-component-patterns';

const MAX_FILE_SIZE_BYTES = 25 * 1024 * 1024;
const ACCEPTED_FILE_TYPES = '.pdf,.jpeg,.png';

export const uiSchema = {
  ...titleUI({
    title: 'Upload your supporting documents',
  }),
  'ui:description': () => (
    <>
      <p data-testid="supporting-documents-instructions">
        You’ll need to upload your verification of enrollment from your prep
        course provider and a receipt correlating to the cost of your prep
        course including any required fees. You’ll need to scan your documents
        onto the device you’re using to submit this application, such as your
        computer, tablet, or mobile phone. You can upload your document from
        there.
      </p>

      <div data-testid="supporting-documents-guidelines">
        <p>Guidelines for uploading a file:</p>
        <ul>
          <li>You can upload a .pdf, .jpeg, or .png file</li>
          <li>Your file should be no larger than 25MB</li>
        </ul>
      </div>
    </>
  ),
  supportingDocuments: fileInputMultipleUI({
    title: 'Upload your supporting documents',
    required: true,
    fileUploadUrl: `${environment.API_URL}/v0/claim_attachments`,
    accept: ACCEPTED_FILE_TYPES,
    maxFileSize: MAX_FILE_SIZE_BYTES,
    formNumber: '22-10272',
    disallowEncryptedPdfs: false,
  }),
};

export const schema = {
  type: 'object',
  properties: {
    supportingDocuments: fileInputMultipleSchema(),
  },
  required: ['supportingDocuments'],
};
